import BoolParameter from './BoolParameter';
import DoubleParameter from './DoubleParameter';
import EnumParameter from './EnumParameter';
import IntParameter from './IntParameter';
import { FC } from 'react';

export type SelectedValueType = string | number | boolean;

export type ParameterProps = {
  name: string;
  name_de: string;
  name_en: string;
  type: string;
  parameter: string;
  required: boolean;
  onChange: (val: SelectedValueType) => void;
  selected: SelectedValueType | undefined;
};

const supportedParameters = { bool: BoolParameter, double: DoubleParameter, enum: EnumParameter, int: IntParameter };

const parameterSelector = (type: string): FC<ParameterProps> => {
  if (type in supportedParameters) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return supportedParameters[type];
  } else {
    throw new Error(`type '${type}' not supported`);
  }
};

export default parameterSelector;
